"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.keepInBounds = exports.getStateViewportByFips = exports.getStateViewport = exports.getClosest = void 0;

var _viewportMercatorProject = _interopRequireDefault(require("viewport-mercator-project"));

var _usStates = require("@hyperobjekt/us-states");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// https://gomakethings.com/how-to-get-the-closest-parent-element-with-a-matching-selector-using-vanilla-javascript/
var getClosest = function getClosest(elem, selector) {
  // Element.matches() polyfill
  if (!Element.prototype.matches) {
    Element.prototype.matches = Element.prototype.matchesSelector || Element.prototype.mozMatchesSelector || Element.prototype.msMatchesSelector || Element.prototype.oMatchesSelector || Element.prototype.webkitMatchesSelector || function (s) {
      var matches = (this.document || this.ownerDocument).querySelectorAll(s),
          i = matches.length;

      while (--i >= 0 && matches.item(i) !== this) {}

      return i > -1;
    };
  } // Get the closest matching element


  for (; elem && elem !== document; elem = elem.parentNode) {
    if (elem.matches(selector)) return elem;
  }

  return null;
};

exports.getClosest = getClosest;

var getStateBoundingBoxByFips = function getStateBoundingBoxByFips(fips) {
  var state = fips ? (0, _usStates.getStateFromFips)(fips) : {
    xmin: -125.0011,
    ymin: 24.9493,
    xmax: -66.9326,
    ymax: 49.5904
  };
  return [[state.xmin, state.ymin], [state.xmax, state.ymax]];
};
/**
 * Returns the bounding box for a state given the abbreviation
 * @param {*} abbr
 */


var getStateBoundingBoxByAbbr = function getStateBoundingBoxByAbbr(abbr) {
  var fips = (0, _usStates.getStateFipsFromAbbr)(abbr);
  return getStateBoundingBoxByFips(fips);
};
/**
 * Returns a viewport for the provided abbreviation and viewport width / height
 * @param {*} abbr
 * @param {*} param1
 */


var getStateViewport = function getStateViewport(abbr, _ref) {
  var width = _ref.width,
      height = _ref.height;
  var viewport = new _viewportMercatorProject["default"]({
    width: width,
    height: height
  });
  var bound = viewport.fitBounds(getStateBoundingBoxByAbbr(abbr), {
    padding: 20
  });
  return bound;
};
/**
 * Returns a viewport for the provided abbreviation and viewport width / height
 * @param {*} abbr
 * @param {*} param1
 */


exports.getStateViewport = getStateViewport;

var getStateViewportByFips = function getStateViewportByFips(fips, _ref2) {
  var width = _ref2.width,
      height = _ref2.height;
  var viewport = new _viewportMercatorProject["default"]({
    width: width,
    height: height
  });
  var bound = viewport.fitBounds(getStateBoundingBoxByFips(fips), {
    padding: 20
  });
  return bound;
};
/**
 * Keeps the provided viewport within the provided bounds
 * @param {*} viewport
 * @param {*} bounds [[minLon, maxLon],[minLat, maxLat]]
 * @returns resulting viewport
 */


exports.getStateViewportByFips = getStateViewportByFips;

var keepInBounds = function keepInBounds(viewport, bounds) {
  if (!bounds || bounds.length !== 2) return viewport;
  var updates = {};
  if (viewport.longitude < bounds[0][0]) updates.longitude = bounds[0][0];
  if (viewport.longitude > bounds[1][0]) updates.longitude = bounds[1][0];
  if (viewport.latitude < bounds[0][1]) updates.latitude = bounds[0][1];
  if (viewport.latitude > bounds[1][1]) updates.latitude = bounds[1][1];
  return _objectSpread(_objectSpread({}, viewport), updates);
};

exports.keepInBounds = keepInBounds;